export const defaultFiscalYearEnd = new Date(2024, 11, 31).toISOString();

export const initialCUData = {
  shippingAddress: ' ',
  billingAddress: ' ',
  email: ' ',
  description: ' ',
  logoUrl: ' ',
  name: 'Credit Union Names',
  fiscalYearEnd: defaultFiscalYearEnd,
  organisationType: 0,
} as const;
